import { NewsItem } from '@aipb/gulliver/catalog/model';
import { InjectionToken } from '@angular/core';

export const NEWS: InjectionToken<NewsItem[]> = new InjectionToken('CATALOG_NEWS');
